import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import env from '@tencent/vft-common/env';
import Version from '@tencent/vft-common/Version';
import tenvideo from '@tencent/vft-common/tenvideo';
import Onview from '@tencent/vft-onview';
import Share from './share';
import Scroll from '../AreaCode/scroll.vue';
import PwdDialog, { getPwd } from '../PwdDialog';
Vue.use(PwdDialog);
var SUPPORTED_APP_VERSION = '6.9.0';
export default {
  name: 'vu-iconshare',
  props: {
    dc: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    shareInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pwdInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    paddingLeft: {
      type: String,
      default: '38px'
    },
    reportModule: {
      type: String,
      default: ''
    },
    usePwd: {
      type: Boolean
    },
    onPwdCancel: {
      type: Function
    },
    wrap: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      isTenvideo: env.isApp,
      appVersion: new Version(tenvideo.getAppVersion() || '0.0.0'),
      channelName: {
        save: '保存本地',
        weixin: '微信',
        wxmoments: '朋友圈',
        doki: 'doki',
        qq: 'QQ',
        qzone: 'QQ空间',
        weibo: '微博'
      }
    };
  },
  computed: {
    channels: function channels() {
      var _this = this;

      var channels = ['save', 'weixin', 'wxmoments', 'doki', 'qq', 'qzone', 'weibo'];

      if (!this.shareInfo.dokiId) {
        channels.splice(3, 1);
      }

      if (Array.isArray(this.dc) && this.dc.length) {
        return channels.filter(function (channel) {
          return _this.dc.indexOf(channel) === -1;
        });
      }

      return channels;
    }
  },
  created: function created() {
    var _this2 = this;

    tenvideo.tenvideoReady(function () {
      TenvideoJSBridge.on('onShareFinish', function () {
        if (_this2.sharing) {
          _this2.$emit('shareFinish');

          _this2.sharing = false;
        }
      });
    });
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs.scroll && _this3.$refs.scroll.refresh();
    });
  },
  methods: {
    save: function save() {
      var _this4 = this;

      var toast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      TenvideoJSBridge.invoke('saveImage', {
        imgbase64String: this.shareInfo.imgbase64,
        needSaveToAlbum: true
      }, function (res) {
        if (!toast) {
          return;
        }

        var json = JSON.parse(res);

        if (json && parseInt(json.errCode) === 0) {
          _this4.toast && _this4.toast("保存到相册成功");
        } else {
          _this4.toast && _this4.toast("保存到相册失败");
        }
      });
    },
    share: function share(channel) {
      var _this5 = this;

      if (!this.shareInfo.imgbase64) {
        return;
      }

      if (channel === 'save') {
        this.save();
        this.$emit('shareClick', channel);
      } else {
        if (channel !== 'doki' && !env.isLiteApp && !this.appVersion.compare(SUPPORTED_APP_VERSION) && this.shareInfo.isShareImageOnly !== false) {
          this.toast && this.toast('当前app版本较低，请升级至6.9.0及以上版本', 5000);
          this.$emit('lowAppVer', '当前app版本较低，请升级至6.9.0及以上版本');
          return;
        }

        this.sharing = true;

        if (this.usePwd && ['weixin', 'wxmoments'].indexOf(channel) > -1) {
          if (this.lockGetPwd) {
            return;
          }

          this.lockGetPwd = true;
          getPwd({
            pageId: this.pwdInfo.pageId,
            jumpUrl: this.pwdInfo.jumpUrl
          }).then(function (res) {
            PwdDialog.$create({
              $props: {
                channel: channel,
                thumbpic: _this5.shareInfo.imgbase64,
                pwds: res[channel]
              },
              $events: {
                cancel: function cancel() {
                  _this5.onPwdCancel && _this5.onPwdCancel();
                }
              }
            }).show();

            if (channel === 'wxmoments') {
              _this5.save(false);
            }

            _this5.$emit('popPwdDialog');
          }, function (e) {
            _this5.toast && _this5.toast('服务异常请重试');
          }).then(function () {
            _this5.lockGetPwd = false;
          });
        } else {
          Share.openShare(channel, _objectSpread({
            isShareImageOnly: true
          }, this.shareInfo));
        }

        this.$emit('shareClick', channel);
      }
    },
    scrollHandler: function scrollHandler() {
      Onview.triggerCompute();
    }
  },
  components: {
    Scroll: Scroll
  },
  reportData: {
    save: {
      f_type: 4,
      f_resource: '保存本地btn'
    },
    weixin: {
      f_type: 4,
      f_resource: '分享微信btn'
    },
    wxmoments: {
      f_type: 4,
      f_resource: '分享朋友圈btn'
    },
    doki: {
      f_type: 4,
      f_resource: '分享dokibtn'
    },
    qq: {
      f_type: 4,
      f_resource: '分享QQbtn'
    },
    qzone: {
      f_type: 4,
      f_resource: '分享QQ空间btn'
    },
    weibo: {
      f_type: 4,
      f_resource: '分享微博btn'
    }
  }
};